// extracted by mini-css-extract-plugin
export default {"wrap":"SearchBar_wrap__fisyE","input":"SearchBar_input__7saUq","icon":"SearchBar_icon__rm0Wj","clear":"SearchBar_clear__5lvsl"};